import { render } from "./_register.vue?vue&type=template&id=217e29db&scoped=true"
import script from "./_register.vue?vue&type=script&lang=js"
export * from "./_register.vue?vue&type=script&lang=js"

import "./_register.vue?vue&type=style&index=0&id=217e29db&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-217e29db"]])

export default __exports__